<template>
    <div>
        <div v-if="preloader">
            <div class="header_button_box">
                <div v-if="$checkUser('shares', 'create')" class="header_button_item">
                    <router-link :to="{name: 'ShareAdd'}">
                        <button class="header_button">
                            <div class="header_icons icon_add" /><span>Создать акцию</span>
                        </button>
                    </router-link>
                </div>
            </div>
            <SearchPlagin :search-type="`Shares`" />
            <div v-if="list && list.length" class="default_box table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" class="text-start">
                                ID
                            </th>
                            <th scope="col" class="text-start">
                                Заголовок
                            </th>
                            <th scope="col" class="text-start">
                                Фильтр
                            </th>
                            <th v-if="$checkUser('shares', 'edit')" scope="col" class="text-end">
                                Опубликовано
                            </th>
                            <th v-if="$checkUser('shares', 'edit') || $checkUser('shares', 'delete')" scope="col" class="text-end">
                                Действия
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in list" :key="index">
                            <th scope="row" class="text-start">
                                <a :href="'https://okaygorod.com/' + $city.index + '/shares/'+item.id" target="_blank" :title="'Открыть ссылку https://okaygorod.com/' + $city.index + '/shares/'+item.id" class="link" v-html="item.id" />
                            </th>
                            <td class="text-start" v-html="$cutText(item.name, 80)" />
                            <td class="text-start" v-html="item.category.title" />
                            <td v-if="$checkUser('shares', 'edit')" class="text-end">
                                <input id="s2" type="checkbox" class="switch" :checked="item.published" :disabled="disabled_status" @change="api_status(item, index)">
                            </td>
                            <td v-if="$checkUser('shares', 'edit') || $checkUser('shares', 'delete')" class="text-end">
                                <div class="table_button_box">
                                    <router-link v-if="$checkUser('shares', 'edit')" :to="{name: 'ShareEdit', params: {id: item.id}}"  class="table_button_item" :title="`Редактировать афишу`">
                                        <button class="table_button table_icon_edit">
                                            <div class="table_icons icon_pen" />
                                        </button>
                                    </router-link>
                                    <div v-if="$checkUser('shares', 'delete')" class="table_button_item" :title="`Удалить афишу`">
                                        <button class="table_button table_icon_delete" @click="del(item.id, item.name, index)">
                                            <div class="table_icons icon_trash" />
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="list && last_page && page < last_page">
                    <div v-if="button_preloader" class="news_button_block">
                        <button class="btn_primary" @click="api_next">
                            Показать ещё
                        </button>
                    </div>
                    <Preloader v-else />
                </div>
            </div>
            <div v-else class="default_box">
                В этом городе нет акций
            </div>
        </div>
        <Preloader v-else />
    </div>
</template>
<script>
import SearchPlagin from "@/components/components/Search/SearchPlagin";
export default {
    name: "ShareList",
    components: {
        SearchPlagin
    },
    data() {
        return {
            disabled_status: false,
            button_preloader: true,
            preloader: false,
            list: null,
            page: 1,
            last_page: null,
        }
    },
    mounted() {
        this.api();
    },
    methods: {
        api() {
            this.preloader = false;
            let url = this.$config.api_management + this.$city.index + "/shares";
            this.$http.get(url, {
                params: {
                    per_page: 50,
                }
            }).then((response) => {
                this.list = response.data.data;
                this.last_page = response.data.last_page;
            }).finally(() => {
                this.preloader = true;
            });
        },
        api_next() {
            this.button_preloader = false;
            let url = this.$config.api_management + this.$city.index + "/shares";
            this.page++;
            this.$http.get(url, {
                params: {
                    page: this.page,
                    per_page: 50,
                }
            }).then((response) => {
                this.list = this.list.concat(response.data.data);
            }).finally(() => {
                this.button_preloader = true;
            })
        },
        api_status(array, index) {
            array.published = !array.published;
            let data = {
                published: array.published
            }
            this.disabled_status = true;
            let url = this.$config.api_management + this.$city.index + "/shares/" + array.id;
            this.$http.put(url, data).then((response) => {
                this.list[index].published = response.data.published;
                this.$toast.default("Статус акции успешно изменён");
            }).finally(() => {
                this.disabled_status = false;
            })
        },
        del(id, name, index) {
            if (confirm("Вы уверены, что хотите удалить эту акцию?\n\n\"" + name + "\"\n\nЭто действие нельзя отменить!")) {
                let url = this.$config.api_management + this.$city.index + "/shares/" + id;
                this.$http.delete(url).then((response) => {
                    if (response && response.status === 204) {
                        this.list.splice(index, 1);
                        this.$toast.default("Акция \"" + name + "\", успешно удалена");
                    } else {
                        this.$toast.error("Произошла ошибка при удалении");
                    }
                })
            }
        },
    }
}
</script>
<style scoped>
.btn_primary {
    margin-top: 50px;
    margin-bottom: 50px;
    padding: 10px 15px;
}
</style>